import { useAppState } from "./useReduxState"
import { FetchState } from "../Models/Client/FetchState"
import { useEffect, useMemo } from "react"
import { useDispatch } from "react-redux"
import { listTags } from "../Actions/API/AppInstance/AppInstanceActions"
import { Result } from "../Models/Utility/Result"
import { getItemList, RemoteData } from "../Models/Client/RemoteData"

export function useTagList(
    appID: string,
    keyword: string
): FetchState<string[]> {
    const key = keyword === "" ? "default" : "filtered"
    const dispatch = useDispatch()
    const entry = useAppState<
        RemoteData<string, { keyword?: string }, string> | undefined
    >(state =>
        appID === undefined ? undefined : state.api.apps.tags[appID]?.get(key)
    )
    const entryKeyword = entry?.list?.params.keyword ?? ""

    useEffect(() => {
        if (
            (entry?.list === undefined || entryKeyword !== keyword) &&
            appID !== undefined
        ) {
            dispatch(listTags(appID, key, keyword))
        }
    }, [dispatch, appID, entry, keyword, entryKeyword, key])

    return useMemo(
        () =>
            entry?.list === undefined
                ? undefined
                : Result.ok(getItemList(entry)),
        [entry]
    )
}
